
import { addDoc, collection, deleteDoc, doc, documentId, getDoc, getDocs, getFirestore, query, setDoc, updateDoc, where } from 'firebase/firestore';
import Agent, { AGENT, agentConverter } from '../entities/Agent';
import { agentShopConverter, AGENT_SHOP } from '../entities/AgentShop';
import firebase from '../firebase/Firebase';
import { sliceByNumber } from '../lib/array';


const store = getFirestore(firebase);

export const getAgentByIds = async (agentIds: string[]) => {
  const ref = collection(store, AGENT).withConverter(agentConverter);
  const sliced = sliceByNumber(agentIds, 10)
  const promises = sliced.map((agentIds) => {
    const q = query(ref,
      where(documentId(), 'in', agentIds)
    )
    return getDocs(q).then((snap) => snap.docs.map((doc) => doc.data()));
  })
  return await Promise.all(promises).then((results) => results.flat())
}

export const getShopAgents = async (shopId: string) => {

  const ref = collection(store, AGENT_SHOP).withConverter(agentShopConverter);
  const q = query(ref,
    where('shopIds', 'array-contains', shopId)
  )
  return await getDocs(q).then((snap) => {
    const agentIds = snap.docs.map((doc) => doc.id);
    return getAgentByIds(agentIds).catch((error) => {
      console.warn(error);
      return null;
    });
  });
};

export const getAgent = async (id: string) => {
  const ref = doc(store, AGENT, id).withConverter(agentConverter);
  return await getDoc(ref).then((snap) => {
    return snap.data();
  });
};

export const getAgentByEmail = async (email: string) => {
  const ref = collection(store, AGENT).withConverter(agentConverter);
  const q = query(ref, where('email', '==', email))
  return await getDocs(q).then((snap) => {
    if (snap.docs.length == 0) {
      return null
    }

    return snap.docs.map((doc) => {
      return doc.data();
    })[0]
  });
}

export const addAgent = async (agent: Agent) => {
  return await addDoc(collection(store, AGENT).withConverter(agentConverter), agent)
    .then((ref) => {
      return ref.id;
    }).catch((error) => {
      console.warn(error);
    });
};

export const setAgent = async (agent: Agent) => {
  const ref = doc(store, AGENT, agent.id).withConverter(agentConverter);
  await setDoc(ref, agent).catch((error) => {
    console.warn(error);
  });
};

export const updateAgent = async (agent: Agent) => {
  const ref = doc(store, AGENT, agent.id).withConverter(agentConverter);
  return await updateDoc(ref, agent).catch((error) => {
    console.warn(error);
  });
};

export const deleteAgent = async (agentId: string) => {
  const ref = doc(store, AGENT, agentId)
  return await deleteDoc(ref).catch((error) => {
    console.warn(error);
  });
};